import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { OpClass, AttrClass } from "./../datas/OpClass";
import { FxUtil } from "./../datas/FxUtil";
import { FxButton2 } from "./FxButton";
import { FxFooter } from "./FxFooter";
import { FxInput } from "./FxInput";

/**
 * 
 * @param {object} props 
 * opId : 운용코드
 * inObj : 편집에 사용할 값 
 * attrList : 화면을 구성할 항목으로 이 값이 존재하면 opId의 화면구성 정보를 무시하고 이 내용을 사용한다.
 * @returns 
 */
export const FxDataEdit = props => {

  const { opId, selectedData, selectedDataId, attrListClass, attr}  = props;
  const [listClass, setListClass] = React.useState(null);
  const [opClass, setOpClass] = React.useState(null);

  const refershGridData = props.refershGridData? props.refershGridData: attr?.callback;
  
  console.log('*** FxDataEdit *** props.attrListClass, attrListClass, opId, selectedData', props.attrListClass, attrListClass, opId, selectedData);

  useEffect(() => {
    if (opId) {
      const op = OpClass.getOpClass(opId);
      if (op) {
        setOpClass(op);
      }
    }
  }, [opId]);

  useEffect(() => {
    if (FxUtil.isEmpty(attrListClass)) return;
    setListClass(attrListClass)
  }, [attrListClass]);

  useEffect(() => {

    if (FxUtil.isEmpty(opClass)) return;

    setListClass(opClass.getAttrListClass());

  }, [opClass]);

  return (
    <FxDataEdit2 attrListClass={listClass} selectedData={selectedData} selectedDataId={selectedDataId} refershGridData={refershGridData} />
  )
};

/**
 * 데이터 편집용
 * @param {attrListClass, selectedData, selectedDataId} props 
 * @returns 
 */
const FxDataEdit2 = props => {

  const { attrListClass, selectedData, selectedDataId, refershGridData } = props;
  const [inputDatas, setInputDatas] = React.useState({ ...selectedData });
  const [children, setChildren] = React.useState([]);
  const [button, setButton] = React.useState([]);
  const newDatas = { ...selectedData };

  // text 박스 변경되면 객체에 값 넣기
  const onChange = (id, value) => {

    updateInputData(id, value);
    let attrClass = attrListClass.getAttrClass(id);
    console.log('*** FxDataEdit *** onChange', id + "=" + value, attrClass);

    if (attrClass) {

      attrClass.onChange(newDatas);

      // 입력된 값에 의해 SELECT박스의 옵션이 변경될 필요가 있을 때 처리한다.
      for (const attrClass of attrListClass.getAttrClassList()) {
        if (attrClass.isSelectBox() && attrClass.getAttr().attrName != id) {
          if (attrClass.getAttr().refreshItems) {
            attrClass.getAttr().refreshItems(id, value);
          }
        }
      }
    }   
  }

  // 버튼 클릭했을 때 처리
  const onClick = (event) => {
    let attrClass = attrListClass.getAttrClass(event.target.id);
    console.log('*** FxDataEdit *** onClick', event.target.id, attrClass);
    if (attrClass) {
      attrClass.onClick(newDatas, selectedDataId, refershGridData);    //FxAction 참조    
    }
  }

  function updateInputData(attrName, attrValue) {

    if (attrValue === null || attrValue === '') {
      delete newDatas[attrName];
    } else {
      newDatas[attrName] = attrValue;
    }

    setInputDatas({ ...newDatas });
    if (props.onChangeDatas) {
      props.onChangeDatas(newDatas);
    }
    console.log('*** FxDataEdit *** updateInputData', newDatas);
  }

  useEffect(() => {

    console.log('*** FxDataEdit2 *** attrListClass, selectedData', attrListClass, selectedData);

    if (FxUtil.isEmpty(attrListClass)) return;

    const tmpObj = { ...selectedData };

    for (const attrClass of attrListClass.getAttrClassList()) {
      const attr = attrClass.getAttr();
      if (attrClass.isButton() !== false && tmpObj[attr.attrName] === undefined) {
        tmpObj[attr.attrName] = '';
        newDatas[attr.attrName] = '';
      }
    }

    setInputDatas(tmpObj);

    //
    // 입력 컴포넌트 보이기
    //
    const para = { onClick: onClick, onChange: onChange, selectedDataId: selectedDataId, selectedData: selectedData };
    const colgroup = [];
    const tbody = [];
    const size = attrListClass.getColSize();
    let index = 0;
    const width = attrListClass.getLabelWidth();
    let temp = [];
    if (width === undefined) width = "120px";

    for (let i = 0; i < size; i++) {
      colgroup.push(<col key={index++} width={width} />);
      if (i + 1 === size) {
        colgroup.push(<col key={index++} width="*" />);
      } else {
        colgroup.push(<col key={index++} width="300px" />);
      }
    }

    for (const line of attrListClass.getInputList()) {
      let tds = [];
      for (const attrClass of line) {
        if (attrClass.isButton()) {
          tds.push(<td key={index++}><FxInput attrClass={attrClass} para={para} colspan="2" /></td>);
          tds.push("");
        }  else {
          tds.push(<th key={index++}>{attrClass.getAttr().attrUiTxt}</th>);
          tds.push(<td key={index++}><FxInput attrClass={attrClass} para={para} /></td>);
        }
      }   
      tbody.push(<tr>{tds}</tr>);
    }

    const btns = [];
    for (const attrClass of attrListClass.getButtonList()) {
      btns.push(<FxButton2 attrClass={attrClass} para={para} />);
    }

    setChildren([<colgroup key="colgrp">{colgroup}</colgroup>, tbody]);
    setButton(btns);

  }, [attrListClass, selectedData]);

  return (
    <div key="FxDataEdit" className="FxDataEdit">
      <table key="FxDataEditTable" className="Table">
        {children}
      </table>
      <div className="ButtonBox">
        {button}
      </div>
      <FxFooter />
    </div>
  )
};